var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"color":_vm.color,"text":"","type":"info","id":_vm.id,"dismissible":_vm.dismissible}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }